import { render, staticRenderFns } from "./shopPetStop.vue?vue&type=template&id=065e3165&scoped=true"
import script from "./shopPetStop.vue?vue&type=script&lang=js"
export * from "./shopPetStop.vue?vue&type=script&lang=js"
import style0 from "./shopPetStop.vue?vue&type=style&index=0&id=065e3165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e3165",
  null
  
)

export default component.exports